import "./PatientEditConfirmationComponent.scss";
import {Field, FieldProps} from "formik";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import DialogComponent from "../../../../shared/components/dialog/dialogComponent";
import React from "react";

interface PatientEditConfirmationComponentProps {
    isOpen: boolean;
    title?: string;
    onSubmit: (() => Promise<void>) & (() => Promise<any>);
    onClose: () => void;
    disabledNext: boolean;
    isSubmitting: boolean;

}

const PatientEditConfirmationComponent = (props: PatientEditConfirmationComponentProps) => {
    const {isOpen, title = 'Add Reason for Edit', onSubmit, disabledNext, isSubmitting, onClose} = props;

    return (
        <DialogComponent
            className={'patient-edit-confirmation-component'}
            open={isOpen}
            direction={"down"}
            title={title}
            // description={"Description"}
            isShowCancel={false}
            maxWidth={'sm'}
        >
            <>
                <div className="mrg-top-20">
                    <Field name={'reasonForEdit'}>
                        {
                            (field: FieldProps) => (
                                <FormikInputComponent
                                    label={'Reason For Edit'}
                                    placeholder={'Enter reason for edit'}
                                    type={"text"}
                                    required={true}
                                    formikField={field}
                                />
                            )
                        }
                    </Field>
                    <div className="disclaimer-text">
                        <b>Warning:</b>
                        <span> Updates to the patient information will reflect on all related test orders.</span>
                    </div>
                </div>
                <div className={'select-lab-dialog-action-wrapper'}>
                    <ButtonComponent
                        variant={'outlined'}
                        color={'primary'}
                        handleClick={onClose}
                    >
                        Cancel
                    </ButtonComponent>
                    <ButtonComponent
                        type={"submit"}
                        isLoading={isSubmitting}
                        variant={'contained'}
                        color={'primary'}
                        disabled={disabledNext}
                        handleClick={onSubmit}
                    >
                        Update
                    </ButtonComponent>
                </div>
            </>
        </DialogComponent>
    );

};

export default PatientEditConfirmationComponent;
